class ReadTime {
  constructor() {
    this.target = document.querySelector('.js-read-time');
    this.main = document.querySelector('.l-main');
    this.charsPerMinute = 500; // 日本語の平均読書速度 約500〜600文字/分
    this.init();
  }

  init() {
    if (!this.target || !this.main) return;
    const charCount = this.main.innerText.replace(/\s+/g, '').length;
    // 小数点切り上げ(文字数 / 500)
    const minutes = Math.ceil(charCount / this.charsPerMinute);
    this.target.textContent = minutes;
  }
}

export default ReadTime;
